export default __webpack_public_path__ + "static/media/bgAboutMobile.82a79014.svg";